import styles from './style.css'
import { dateFormatter, formatDecimal, rupiah } from 'utils/formatter'

class LoyaltyMembership extends React.Component {
  render () {
    let {customerDetail} = this.props
    return (
      <div className='customer-info-box'>
        <div className={'header ' + styles['header-name']}>
          Loyalty Membership
        </div>
        {customerDetail && customerDetail.loyalty_membership_info
          ? <div className='info-profile'>
            <table>
              <tbody className={styles['no-hover']}>
                <tr>
                  <td className='text-left col-md-6'>
                    Member Since
                  </td>
                  <td className={'text-left col-md-6'}>
                    {dateFormatter(customerDetail.loyalty_membership_info.join_date)}
                  </td>
                </tr>
                <tr>
                  <td className='text-left col-md-6'>
                    Member Number
                  </td>
                  <td className='text-left col-md-6'>
                    {customerDetail.phone}
                  </td>
                </tr>
                <tr>
                  <td className='text-left col-md-6'>
                    Current Balance Point
                  </td>
                  <td className={'text-left col-md-6'}>
                    {formatDecimal(customerDetail.loyalty_membership_info.point_balance)} Points
                  </td>
                </tr>
                <tr>
                  <td className='text-left col-md-6'>
                    Reward Redeemed
                  </td>
                  <td className='text-left col-md-6'>
                    {formatDecimal(customerDetail.loyalty_membership_info.reward_redeemed)} Times
                  </td>
                </tr>
                <tr>
                  <td className='text-left col-md-6'>
                    Member Spending
                  </td>
                  <td className='text-left col-md-6'>
                    {rupiah(customerDetail.loyalty_membership_info.member_spending)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          : <div className={`${styles['no-loyalty-membership']}`}> <i>Not a member</i></div>
        }
      </div>
    )
  }
}

LoyaltyMembership.propTypes = {
  customerDetail: React.PropTypes.object
}

export default LoyaltyMembership



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/CustomerDetail/LoyaltyMembership.js